import React, { useEffect, useState, useRef } from "react";
import PageLayout from "layouts/PageLayout";
import { Box } from "@material-ui/core";
import Table from "components/ReactTable/ReactTableV2";
import ManagerSummarySection from "components/ManagerSummarySection/ManagerSummarySection";
import ExportOrdersModal from "components/ExportOrdersModal/ExportOrdersModal";
import FiltersHeader from "./FiltersHeader";
import columns from "./columns";
import useDealers from "hooks/useDealersSwr";
import useSubscriptions from "hooks/useSubscriptions";
import { useBackdrop } from "hooks/useBackdrop";

export default function StoreManager() {
    const { subscriptions = [], isLoading } = useSubscriptions();
    const [selectedPlanId, setSelectedPlanId] = useState("");
    const [pageIndex, setPageIndex] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [search, setSearch] = useState("");
    const [searchValue, setSearchValue] = useState("");

    const { openBackdrop, closeBackdrop } = useBackdrop();
    const isFirstRender = useRef(true);

    const filters = [
        { label: "All", value: "" },
        ...subscriptions.map((s) => ({ label: s.name, value: s.id })),
    ];

    const { dealers = [], totalCount = 0, isLoading: loadingDealers } = useDealers(
        selectedPlanId,
        pageIndex,
        pageSize,
        search
    );

    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }

        if (loadingDealers) {
            openBackdrop("Loading dealers");
        } else {
            closeBackdrop();
        }
    }, [loadingDealers]);

    const handleFilterChange = (planId) => {
        setSelectedPlanId(planId);
        setPageIndex(1);
        setSearch(""); // backend
        setSearchValue(""); // frontend input
    };

    const handleSearchChange = (value) => {
        setSearchValue(value);
        setSearch(value);
        setPageIndex(1);
    };

    return (
        <PageLayout
            showSelectDealer={false}
            customComponent={
                <Box marginTop={1} marginRight={1.5} textAlign="right">
                    <ExportOrdersModal />
                </Box>
            }
        >
            <ManagerSummarySection subscriptionPlanId={selectedPlanId} />
            <FiltersHeader
                selectedPlanId={selectedPlanId}
                setSelectedPlanId={handleFilterChange}
                filters={filters}
                isLoading={isLoading}
                searchValue={searchValue}
                setSearchValue={setSearchValue}
                onSearchChange={handleSearchChange}
            />
            <Table
                columns={columns}
                data={dealers?.data || []}
                fetchData={({ pageIndex, pageSize }) => {
                    setPageIndex(pageIndex);
                    setPageSize(pageSize);
                }}
                pageCount={Math.ceil(totalCount / pageSize)}
                manualPagination={true}
                pageIndex={pageIndex}
                rows={pageSize}
                loading={loadingDealers}
                showSorting={false}
            />
        </PageLayout>
    );
}
